import {gql, useQuery} from "@apollo/client";
import {EventType, License} from "../../../../schema";
import UnexpectedErrorScene from "../../../system/UnexpectedErrorScene";
import React, {useMemo} from "react";
import Tip, {TipType} from "../../../../ui/Tip";
import Avatar from "../../../../ui/Avatar";
import {Link} from "react-router-dom";
import UILink from "../../../../ui/UILink";
import {reverse} from "../../../../urls";
import cn from "classnames";

type LicensesTab = {
  licenseeId: string;
}

function SublicenseRow({
                         licenseeId,
                         subLicense,
                       }: { licenseeId: string, subLicense: License }) {

  return (
    <tr
      className={cn('border-b last:border-b-0 border-gray-light cursor-pointer hover:bg-blue-section', {'text-gray': !subLicense.active})}
      key={subLicense.id}
      onClick={() => window.location.assign(reverse('licensee_profile', {id: subLicense.licensee.id}))}>
      <td className="flex p-3">
        <Avatar name={subLicense.licensee.name}
                url={subLicense.licensee.avatar ? subLicense.licensee.avatar : undefined}
                className="w-6 h-6 rounded-full mr-2 -mt-0.5"/>
        {subLicense.licensee.name}
      </td>
      <td className="text-right pr-10">{subLicense.expiresAt}</td>
    </tr>
  )
}

export function SublicensesTab({
                                 licenseeId
                               }
                                 :
                                 LicensesTab
) {

  const {loading, data, error} = useQuery<SublicensesQuery>(query, {
    variables: {id: licenseeId}
  });

  const subLicenses = useMemo(() => {
    const unsorted: License[] = [];
    data?.subLicenses.forEach(type => unsorted.push(type));
    return unsorted.sort((a, b) => a.licensee.name.localeCompare(b.licensee.name));
  }, [data]);

  if (error) {
    return <UnexpectedErrorScene
      error={error}
      errorInfo={null}
      eventId={null}
    />;
  }

  return (
    <div className="mt-8 flex flex-row">
      <div className="flex flex-col w-1/2">
        {!loading && !!data && (
          <>
            <table>
              <thead>
              <tr className="mb-4 border-b border-gray-light">
                <th className="text-left pl-4 py-3">Trainer</th>
                <th className="text-right pr-16 py-3">Expires</th>
              </tr>
              </thead>
              <tbody>
              {subLicenses.map((license) =>
                <SublicenseRow licenseeId={licenseeId} subLicense={license} key={license.id}/>
              )}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
}

interface SublicensesQuery {
  subLicenses: License[];
  eventTypes: EventType[];
}

const query = gql`
  query SublicensesQuery($id: ID!) {
    subLicenses: licenseeSublicenses(licenseeId: $id) {
      id
      active
      expiresAt
      licensee {
        id
        name
        avatar
      }
    },
    eventTypes: eventTypes {
      id
      name
    }
  }
`;
